import React, { useState } from 'react';
import logo from '../../assets/img/logo.svg';
import placeholder from "../../assets/img/illu/contract-placeholder.png";
import download from "../../assets/img/ico/download.svg";
import eye from "../../assets/img/ico/eye.svg";

function ContratDetails({ timesheet, onUpdate, onDeselect }) {

    const handleChange = (field, value) => {
        const updated = { ...timesheet, [field]: value };
        onUpdate(updated);
    };

    if (!timesheet) {
        return <div className="timesheet-details"><p>Sélectionnez un contrat à gauche.</p></div>;
    }

    return (
        <div className="timesheet-details">
            { window.innerWidth <= 1100 &&
                (<div className={`status ${timesheet.status === 'À SIGNER' ? 'todo' : 'archived'}`}>
                        {timesheet.status}
                    </div>
                )}
            {/* Bouton retour visible uniquement en mobile */}

            <div className="timesheet-details-body">
                <div className={"left"}>
                    <div className="timesheet-details-head">
                        <img src={logo} alt="icon" />
                        <div>
                            <p>CONTRAT N°{timesheet.number}</p>
                            <h3>{timesheet.date}</h3>
                            <p>{timesheet.name}</p>
                        </div>
                    </div>
                <div>
                    <h4>Date de début</h4>
                    <p>{timesheet.startDate}</p>
                </div>
                <div>
                    <h4>Date de fin</h4>
                    <p>{timesheet.endDate}</p>
                </div>
                <div>
                    <h4>Durée</h4>
                    <p>{timesheet.workedDays} jours</p>
                </div>
                <div>
                    <h4>Taux horaire brut</h4>
                    <p> 11.04€ </p>
                </div>
                <div>
                    <button className={"btn fill green"}>Signer</button>
                </div>
                {onDeselect && window.innerWidth <= 1100 && (
                    <button className="btn empty" onClick={onDeselect}>
                        ⬅ Retour
                    </button>
                )}
                </div>
                <div className={"right"}>
                    { window.innerWidth > 1100 &&
                        (<div className={`status ${timesheet.status === 'À SIGNER' ? 'todo' : 'archived'}`}>
                                {timesheet.status}
                            </div>
                        )}
                    <div className={"cta-container"}>
                        <img src={eye}></img>
                        <img src={download}></img>
                    </div>
                    <div>
                        {/* Div servant à afficher l'image */}
                        <img src={placeholder} />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ContratDetails;
